import { useEffect } from 'react';
export const useInitialValue = ({ mode, selectedValues, setValue, optionsCache, }) => {
    useEffect(() => {
        if (mode === 'single' && selectedValues && selectedValues.length > 0) {
            const option = optionsCache.current.get(selectedValues[0]);
            setValue(option != null ? option.label : selectedValues[0]);
        }
    }, [mode, optionsCache]);
};
